import { useState } from 'react';

import clsx from 'clsx';

import { useStyles } from './index.style';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { DashboardLayoutProps } from './types';

const DashboardLayout = ({ children }: DashboardLayoutProps) => {
  const classes = useStyles();
  const [isNavOpen, setNavOpen] = useState<boolean>(false);

  return (
    <div className={classes.root}>
      <TopBar />
      <NavBar open={isNavOpen} onToggle={() => setNavOpen((prev) => !prev)} />
      <div
        className={clsx(classes.wrapper, {
          [classes.wrapperShift]: isNavOpen,
        })}
      >
        <div className={classes.contentContainer}>
          {children && (
            <div id="scrollable-content" className={classes.content}>
              {children}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
